import hotkeys from 'hotkeys-js';
import type {KeyboardShortcutScope} from '@Libraries/keyboard-shortcuts';

const MOVEMENT_SHORTCUTS = [
  'up',
  'down',
  'left',
  'right',
  'shift+up',
  'shift+down',
  'shift+left',
  'shift+right',
  'up+left',
  'left+up',
  'up+right',
  'right+up',
  'down+right',
  'right+down',
  'down+left',
  'left+down',
];

export interface NudgeValues {
  x: number;
  y: number;
}

let lastSetTimeOut = Date.now();
let isLongKeyPressed = false;
let lastKeyUpAt = Date.now();

const NUDGE_DEFAULT_VALUE = 1;
const NUDGE_HOLD_VALUE = 5;
const NUDGE_MULTIPLIED_VALUE = 10;

export const initPosterItemKeyboardMovement = (scope: KeyboardShortcutScope, onNudgeItem: (values: NudgeValues) => void, onNudgeItemEnd?: () => void): void => {
  hotkeys(
    MOVEMENT_SHORTCUTS.join(','),
    {
      scope,
      keydown: true,
      keyup: false,
    },
    (event) => {
      event.preventDefault();
      onNudgeItem(getNudgeValues());
    }
  );

  hotkeys(
    MOVEMENT_SHORTCUTS.join(','),
    {
      scope,
      keydown: false,
      keyup: true,
    },
    () => {
      onKeyUp();
      if (onNudgeItemEnd) {
        onNudgeItemEnd();
      }
    }
  );
};

const onKeyUp = (): void => {
  lastKeyUpAt = Date.now();
  if (isLongKeyPressed) {
    isLongKeyPressed = false;
  }
};

const getNudgeValues = (): NudgeValues => {
  const keyDownAt = Date.now();
  // check if last setTimeout call has passed 500 ms.
  if (keyDownAt - lastSetTimeOut >= 500) {
    lastSetTimeOut = Date.now();
    // Use a timeout with 500 ms
    setTimeout(() => {
      // Compare key down time with key up time
      if (keyDownAt > lastKeyUpAt) {
        isLongKeyPressed = true;
        // Key has been held down for 750 ms
      }
    }, 500);
  }

  const nudgeValue = getNudgeValue();
  let x = 0;
  let y = 0;

  if (hotkeys.isPressed('up')) {
    y -= nudgeValue;
  }

  if (hotkeys.isPressed('down')) {
    y += nudgeValue;
  }

  if (hotkeys.isPressed('left')) {
    x -= nudgeValue;
  }

  if (hotkeys.isPressed('right')) {
    x += nudgeValue;
  }

  return {
    x,
    y,
  };
};

const getNudgeValue = (): number => {
  if (hotkeys.isPressed('shift')) {
    return NUDGE_MULTIPLIED_VALUE;
  }
  return isLongKeyPressed ? NUDGE_HOLD_VALUE : NUDGE_DEFAULT_VALUE;
};
